/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is gitignored and regenerated by
 * script/remote_lookup/update-ignored-files.ts via `yarn update-generated-files`.
 *
 * @owner @Appboy/messaging-experience
 *
 * Friendly aliases over the cross-type generated modules for the
 * "sparse_segment" remote lookup provider. Items are server output (the Output
 * variants); ids and filters are client-constructed input (the unsuffixed
 * variants).
 */
import type { z } from "zod";

import type { RemoteLookupProvider } from "../providers/types";

import type { IdType } from "../../../../cross_type/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider/id_type.types";
import type { ItemTypeOutput } from "../../../../cross_type/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider/item_type.types";
import type { FiltersType } from "../../../../cross_type/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider/filters_type.types";

import { idTypeSchema } from "../../../../cross_type/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider/id_type.schemas";
import { itemTypeOutputSchema } from "../../../../cross_type/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider/item_type.schemas";
import { filtersTypeSchema } from "../../../../cross_type/braze/remote_lookup/providers/sparse_segment_remote_lookup_provider/filters_type.schemas";

export type SparseSegmentRemoteLookupId = IdType;
export type SparseSegmentRemoteLookupItem = ItemTypeOutput;
export type SparseSegmentRemoteLookupFilters = FiltersType;

export type SparseSegmentRemoteLookupProvider = RemoteLookupProvider<
  SparseSegmentRemoteLookupId,
  SparseSegmentRemoteLookupItem,
  SparseSegmentRemoteLookupFilters
>;

// The casts absorb zod's invariance over nullable/optional object properties;
// the schemas and interfaces are generated from the same source schema, so the
// shapes are exact.
export const sparseSegmentRemoteLookupValidators = {
  id: idTypeSchema as z.ZodType<SparseSegmentRemoteLookupId>,
  item: itemTypeOutputSchema as z.ZodType<SparseSegmentRemoteLookupItem>,
  filters: filtersTypeSchema as z.ZodType<SparseSegmentRemoteLookupFilters>,
};
